import React from "react";
import VAFamily from "../../PicesForPages/VA_family.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function VALoans() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent VALoansPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={VAFamily}
          alt="FHAFamilyImage"
          className="background-video VA_FamilyImage"
        />
        <div className="purchasetopBox VALoansPageTopBox">
          {/* The existing Purchase span */}
          <span>VA Loans</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              VA mortgage loans are widely regarded as one of the most secure
              and advantageous options for purchasing a home. Active duty
              service members are fully eligible to take advantage of these
              loans. In addition, Disabled Veterans may qualify for enhanced
              benefits. The VA Home Mortgage Program offers exceptional
              flexibility, allowing eligible borrowers to use it multiple times
              with no fixed usage limit.
            </span>
            <span className="purchaseBottomLeftContent">
              These loans are available not only to members of the Army, Navy,
              Air Force, and Marines, but also to Reservists and National Guard
              members.
            </span>
            <span className="purchaseBottomLeftContent">
              Under the recently enacted Veterans Benefit Act, the VA loan limit
              has increased to $510,400 for zero down payment loans. It has also
              broadened eligibility for Veterans and active duty personnel while
              delivering additional benefits to Disabled Veterans.
            </span>

            <span className="purchaseBottomLeftHeader">
              Key benefits of the VA Mortgage Loan Program include:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>
                VA loans provide 100% financing for loan amounts up to $510,400.
              </li>
              <li>Monthly Homeowner’s Insurance is not required.</li>
              <li>Many VA loans are fully assumable.</li>
              <li>
                Qualifying for a VA loan is generally easier than for a
                conventional loan.
              </li>
              <li>VA loans offer flexible refinancing options.</li>
            </ul>

            <span className="purchaseBottomLeftSubHeader">
              Regarding No Money Down Up to $510,400:
            </span>
            <span className="purchaseBottomLeftContent">
              Qualified borrowers can secure a VA Home Mortgage Loan with no
              down payment for amounts up to $510,400. If the seller agrees to
              pay the closing costs, you may be able to purchase a home with
              zero out-of-pocket expenses. The purchase agreement can be
              structured so that the VA loan covers the entire sales price while
              the seller handles the closing costs.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              The VA Funding Fee:
            </span>
            <span className="purchaseBottomLeftContent">
              The VA applies a Funding Fee on all VA loans, typically ranging
              from 0.5% to 3%. By comparison, FHA loans require a minimum down
              payment of 3.5%. This fee is financed into the loan amount and
              repaid over time. It serves as an alternative to the higher
              mortgage insurance costs found in conventional loans. Disabled
              Veterans may qualify for a full waiver of this fee.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Assumable VA Mortgage Loans:
            </span>
            <span className="purchaseBottomLeftContent">
              VA loans are assumable, allowing a qualified borrower to take over
              the existing mortgage without impacting the original veteran’s
              eligibility. However, Veterans should carefully evaluate the terms
              before proceeding, as VA loan benefits are highly valuable.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Qualifying for a VA Mortgage Loan:
            </span>
            <span className="purchaseBottomLeftContent">
              The VA offers flexible qualification guidelines. Credit scores are
              not the sole determining factor, so even borrowers who have
              experienced past financial challenges but now maintain a strong
              payment history may still qualify. This provides a significant
              advantage over conventional loans, particularly for those with
              lower credit scores.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Refinancing VA Mortgage Loans:
            </span>
            <span className="purchaseBottomLeftContent">
              VA loans also provide a streamlined refinancing option through the
              Interest Rate Reduction Loan (IRRRL) program. This program
              typically does not require credit checks, appraisals, or income
              and asset verification. Additionally, refinancing costs can be
              rolled into the loan, minimizing or eliminating out-of-pocket
              expenses.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default VALoans;
